import React from 'react';

const S = ({
    w = 'w-full',
    h = 'h-4',
    r = 'rounded-lg',
    cls = '',
}: {
    w?: string;
    h?: string;
    r?: string;
    cls?: string;
}) => (
    <div
        className={`${w} ${h} ${r} ${cls} flex-shrink-0`}
        style={{
            background: 'linear-gradient(90deg,var(--v2-border-subtle) 25%,var(--v2-border-card) 50%,var(--v2-border-subtle) 75%)',
            backgroundSize: '200% 100%',
            animation: 'skeletonShimmer 1.6s ease-in-out infinite',
        }}
    />
);

const SampleListSkeleton: React.FC = () => (
    <div className="flex gap-3 v2-animate-fade-in" style={{ minHeight: 320 }}>
        <div className="w-56 flex-shrink-0 rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] p-3 flex flex-col gap-2.5" style={{ boxShadow: 'var(--v2-shadow-card)' }}>
            <S w="w-12" h="h-2.5" r="rounded-md" />
            <S w="w-40" h="h-3" r="rounded-md" />
            <div className="h-px bg-[var(--v2-border-subtle)]" />
            <S w="w-24" h="h-2.5" r="rounded-md" />
            {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex items-center gap-2 py-1.5 border-b border-[var(--v2-border-divider)] last:border-0">
                    <S w="w-4" h="h-4" r="rounded-md" />
                    <S w="w-28" h="h-2.5" r="rounded-md" />
                </div>
            ))}
        </div>

        <div className="flex-1 rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] overflow-hidden flex flex-col" style={{ boxShadow: 'var(--v2-shadow-card)' }}>
            <div className="flex items-center justify-between px-4 py-3 border-b border-[var(--v2-border-subtle)]">
                <div className="flex items-center gap-2">
                    <S w="w-20" h="h-2.5" r="rounded-md" />
                    <S w="w-5" h="h-4" r="rounded-full" />
                </div>
                <S w="w-28" h="h-8" r="rounded-xl" />
            </div>
            {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="px-4 py-3.5 border-b border-[var(--v2-border-divider)] last:border-0 flex flex-col gap-2">
                    <div className="flex items-center gap-3">
                        <S w="w-9" h="h-9" r="rounded-xl" />
                        <div className="flex flex-col gap-1.5 flex-1">
                            <S w="w-32" h="h-3" r="rounded-md" />
                            <S w="w-20" h="h-2" r="rounded-md" />
                        </div>
                        <S w="w-20" h="h-5" r="rounded-full" />
                    </div>
                    <div className="flex gap-2 ml-12">
                        <S w="w-20" h="h-7" r="rounded-lg" />
                        <S w="w-24" h="h-7" r="rounded-lg" />
                        <S w="w-7" h="h-7" r="rounded-lg" />
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default SampleListSkeleton;
